import { useCallback } from "react";

type UseChartEventHandlersProps = {
  setIsActiveDotShown: (value: boolean) => void;
  chartRef: React.RefObject<any>;
  isLineVisible?: boolean;
};

/**
 * Chartコンポーネントのイベントハンドラーを提供するカスタムフック
 * タッチイベントとマウスイベント処理の重複を解消します
 */
export const useChartEventHandlers = ({ setIsActiveDotShown, chartRef, isLineVisible }: UseChartEventHandlersProps) => {
  const handleTouchEndCancel = useCallback(() => {
    setIsActiveDotShown(false);
    chartRef.current?.handleItemMouseLeave?.();
  }, [setIsActiveDotShown, chartRef]);

  const handleMouseDown = useCallback(() => {
    if (!isLineVisible) return;
    setIsActiveDotShown(true);
  }, [isLineVisible, setIsActiveDotShown]);

  const handleMouseMove = useCallback(() => {
    if (!isLineVisible) return;
    setIsActiveDotShown(true);
  }, [isLineVisible, setIsActiveDotShown]);

  const handleMouseUp = useCallback(() => {
    if (!isLineVisible) return;
    setIsActiveDotShown(false);
    chartRef.current?.handleItemMouseUp?.();
  }, [isLineVisible, setIsActiveDotShown, chartRef]);

  const handleMouseLeave = useCallback(() => {
    if (!isLineVisible) return;
    setIsActiveDotShown(false);
    chartRef.current?.handleItemMouseLeave?.();
  }, [isLineVisible, setIsActiveDotShown, chartRef]);

  return {
    handleTouchEndCancel,
    handleMouseDown,
    handleMouseMove,
    handleMouseUp,
    handleMouseLeave,
  };
};
